const hoverDebounceTimeoutMS = 150;
let hoverDebounce = null;

export const bootstrapTabHoverListener = () => {
    const tabHoverElements = [...document.querySelectorAll('.js-bootstrap-tab-hover')].filter(
        (el) => !el.dataset.tabHoverInitialized
    );

    tabHoverElements.forEach((el) => {
        const tabInstance = window.bootstrap.Tab.getOrCreateInstance(el);

        el.addEventListener('mouseenter', () => {
            clearTimeout(hoverDebounce);
            hoverDebounce = setTimeout(() => {
                tabInstance?.show();
            }, hoverDebounceTimeoutMS);
        });

        el.addEventListener('mouseleave', () => {
            clearTimeout(hoverDebounce);
        });

        el.dataset.tabHoverInitialized = true;
    });
};
